/* eslint-disable prettier/prettier */
/* eslint-disable import/no-cycle */
import * as Yup from 'yup'
import { Profile } from './types'

export enum DOCUMENT_TYPE {
  CIN = 'CIN',
  GSTIN = 'GSTIN',
  PAN = 'PAN'
}

export enum PROFILE_FORM_FIELDS {
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  WEBSITE_URL = 'websiteUrl',
  COUNTRY = 'country',
  PROVINCES = 'state',
  DISTRICT = 'district',
  SUB_DISTRICT = 'taluka',
  Village = 'village',
  imageUrl = 'imageUrl',
  USER_EMAIL = 'lastModifiedBy',
  USER_FIRSTNAME= 'firstName',
  USER_LASTNAME = 'lastName',
  PHONE_NO = 'phoneNo',
  DOCUMENTDTO = 'documentDTO',
  ADDRESS = 'addressLine1'
}
export interface IProfileForm {
  [PROFILE_FORM_FIELDS.ID]: string;
  [PROFILE_FORM_FIELDS.NAME]: string;
  [PROFILE_FORM_FIELDS.EMAIL]: string;
  [PROFILE_FORM_FIELDS.WEBSITE_URL]: string;
  [PROFILE_FORM_FIELDS.USER_EMAIL]: string;
  [PROFILE_FORM_FIELDS.USER_FIRSTNAME]: string;
  [PROFILE_FORM_FIELDS.USER_LASTNAME]: string;
  [PROFILE_FORM_FIELDS.COUNTRY]: string;
  [PROFILE_FORM_FIELDS.PROVINCES]: string;
  [PROFILE_FORM_FIELDS.imageUrl]: string;
  [PROFILE_FORM_FIELDS.DISTRICT]: string;
  [PROFILE_FORM_FIELDS.SUB_DISTRICT]: string;
  [PROFILE_FORM_FIELDS.Village]: string;
  [PROFILE_FORM_FIELDS.PHONE_NO]: string;
  [PROFILE_FORM_FIELDS.ADDRESS]: string;
  [PROFILE_FORM_FIELDS.DOCUMENTDTO]: Array<{
    fileInfo: string | File | null,
    documentType: string,
    documentNo: string,
    imageUrls: string | File | null
  }>;
}

export const ProfileFormLabels: Record<string, string> = {
  [PROFILE_FORM_FIELDS.ID]: 'ID',
  [PROFILE_FORM_FIELDS.NAME]: 'Company Name',
  [PROFILE_FORM_FIELDS.EMAIL]: 'Email',
  [PROFILE_FORM_FIELDS.WEBSITE_URL]: 'Website Url',
  [PROFILE_FORM_FIELDS.COUNTRY]: 'Country',
  [PROFILE_FORM_FIELDS.imageUrl]: 'Image',
  [PROFILE_FORM_FIELDS.PROVINCES]: 'State',
  [PROFILE_FORM_FIELDS.DISTRICT]: 'District',
  [PROFILE_FORM_FIELDS.SUB_DISTRICT]: 'Sub-District',
  [PROFILE_FORM_FIELDS.USER_EMAIL]: 'Email',
  [PROFILE_FORM_FIELDS.USER_FIRSTNAME]: 'First Name',
  [PROFILE_FORM_FIELDS.USER_LASTNAME]:  'Last Name',
  [PROFILE_FORM_FIELDS.Village]: 'Village',
  [PROFILE_FORM_FIELDS.PHONE_NO]: 'Phone No',
  [PROFILE_FORM_FIELDS.ADDRESS]: 'Address'
}

export const defaultProfileFormValues: IProfileForm = {
  [PROFILE_FORM_FIELDS.ID]: '',
  [PROFILE_FORM_FIELDS.NAME]: '',
  [PROFILE_FORM_FIELDS.EMAIL]: '',

  [PROFILE_FORM_FIELDS.WEBSITE_URL]: '',
  [PROFILE_FORM_FIELDS.USER_EMAIL]: '',
  [PROFILE_FORM_FIELDS.USER_FIRSTNAME]: '',
  [PROFILE_FORM_FIELDS.USER_LASTNAME]: '',
  [PROFILE_FORM_FIELDS.ADDRESS]: '',
  [PROFILE_FORM_FIELDS.COUNTRY]: '',
  [PROFILE_FORM_FIELDS.PROVINCES]: '',
  [PROFILE_FORM_FIELDS.imageUrl]: '',
  [PROFILE_FORM_FIELDS.DISTRICT]: '',
  [PROFILE_FORM_FIELDS.SUB_DISTRICT]: '',

  [PROFILE_FORM_FIELDS.Village]: '',
  [PROFILE_FORM_FIELDS.PHONE_NO]: '',

  [PROFILE_FORM_FIELDS.DOCUMENTDTO]: [
    {
      documentType: '',
      documentNo: '',
      imageUrls: '',
      fileInfo: ''
    }
  ]
}
export const convertFileToBase64 = (
  file: File
): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
    reader.readAsDataURL(file)
  })
}

export const getInitialProfileFormValueFromResponse = (
  profile: Profile
): IProfileForm => ({
  id: profile?.company?.id ?? '',
  name: profile?.company?.name ?? '',
  email: profile?.company?.email ?? '',
  phoneNo: profile?.company?.phoneNo ?? '',
  websiteUrl: profile?.company?.websiteUrl ?? '',
  country: profile?.company?.country?.id ?? '',
  addressLine1: profile?.company?.addressLine1 ?? '',
  state: profile?.company?.state?.id ?? '',
  imageUrl: profile?.user?.imageUrl ?? '',
  district: profile?.company?.district?.id ?? '',
  taluka: profile?.company?.taluka?.id ?? '',
  village: profile?.company?.village?.id ?? '',
  lastModifiedBy: profile?.user?.email ?? '',
  firstName: profile?.user?.firstname ?? '',
  lastName: profile?.user?.lastname ?? '',
  documentDTO: profile?.documentDTOS?.map((doc) => ({
    documentType: doc.documentType ?? '',
    documentNo: doc.documentNo ?? '',
    imageUrls: doc.imageUrls ?? null,
    fileInfo: doc.imageUrls ?? null
  })) ?? [{ documentType: '', documentNo: '', imageUrls: null, fileInfo: null }]
})

export const profileValidationSchema = Yup.object().shape({
  [PROFILE_FORM_FIELDS.NAME]: Yup.string()
    .required('Company Name is required')
    .max(40, 'Company name must be at most 40 characters'),
  [PROFILE_FORM_FIELDS.EMAIL]: Yup.string()
    .email('Email must be a valid email address')
    .required('Email is required'),
  [PROFILE_FORM_FIELDS.WEBSITE_URL]: Yup.string()
    .url('Website URL must be a valid URL')
    .required('Website URL is required'),
  [PROFILE_FORM_FIELDS.ADDRESS]: Yup.string().required('Address is Required'),
  [PROFILE_FORM_FIELDS.COUNTRY]: Yup.string().required('Country is required'),
  [PROFILE_FORM_FIELDS.PROVINCES]: Yup.string().required('State is required'),
  [PROFILE_FORM_FIELDS.DISTRICT]: Yup.string().required('District is required'),
  [PROFILE_FORM_FIELDS.SUB_DISTRICT]: Yup.string().required(
    'Subdistrict is required'
  ),
  [PROFILE_FORM_FIELDS.Village]: Yup.string().required('Village is required'),
  [PROFILE_FORM_FIELDS.PHONE_NO]: Yup.string()
    .matches(/^\d{10}$/, 'Phone number must be a valid 10-digit number')
    .required('Phone number is required'),
  [PROFILE_FORM_FIELDS.DOCUMENTDTO]: Yup.array().of(
    Yup.object().shape({
      documentType: Yup.string().required('Document Type is required'),
      documentNo: Yup.string().required('Document Number is required'),
      imageUrls: Yup.string().nullable().required('Document image is required')
    })
  )
})
